<template>
<div class="chapter">
<div class="inner_page">
<h1 class="preface-title"><a href="#/toc#toc-preface001">List of Illustrations</a></h1>
<p class="noindent1"><a href="#/preface003#fig001">Iris MacFarlane and her children, Assam, 1950</a></p>
<p class="noindent"><span href="#/chapter002#fig002" title="Link target outside of Sample">A London Tavern, 1600</span></p>
<p class="noindent"><span href="#/chapter004#fig003" title="Link target outside of Sample">A traditional Japanese Tea Ceremony</span></p>
<p class="noindent"><span href="#/chapter006#fig004" title="Link target outside of Sample">Clippers owned by the East India Tea Company, circa 1860</span></p>
<p class="noindent"><span href="#/chapter008#fig005" title="Link target outside of Sample">Horniman’s Tea Advertisement 1880–1899</span></p>
<p class="noindent"><span href="#/chapter010#fig006" title="Link target outside of Sample">Tibetan men carrying brick tea from China, circa 1900</span></p>
<p class="noindent"><span href="#/chapter012#fig007" title="Link target outside of Sample">Elephants clearing a plantation, Assam, 1880</span></p>
<p class="noindent"><span href="#/chapter014#fig008" title="Link target outside of Sample">Pleasure Brand Advertisement, 1888</span></p>
<p class="noindent"><span href="#/chapter016#fig009" title="Link target outside of Sample">Mazawattee tea/John Bull advertisement, 1890</span></p>
<p class="noindent"><span href="#/chapter018#fig010" title="Link target outside of Sample">A typical Chinese plantation</span></p>
<p class="noindent"><span href="#/chapter020#fig011" title="Link target outside of Sample">Henry Cotton, Chief Commissioner of Assam in 1896</span></p>
<p class="noindent"><span href="#/chapter022#fig012" title="Link target outside of Sample">Women working on plantation, circa 1990</span></p>
<p class="noindent"><span href="#/chapter024#fig013" title="Link target outside of Sample">A herbal pharmacopoeia in Tokyo</span></p>
<p class="noindent"><span href="#/chapter026#fig014" title="Link target outside of Sample">Camellia Sinensis, 19th century</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface001.vue?711990f3